import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import Body from './Body';

const styles = theme => ({
  root: {
    marginTop: theme.spacing(4),
  },
  body: {},
  footer: {},
});

function InsightsLayout({
  classes,
}) {
  const { onboardingStepResource } = useSurveyContext();

  const { onSubmit: onSubmitMetaForm } = useMetaLayoutContext();

  return (
    <div className={classes.root}>
      <Body
        className={classes.body}
        onboardingStepResource={onboardingStepResource}
      />
      <SurveyStepFooter
        className={classes.footer}
        onSubmit={onSubmitMetaForm}
      />
    </div>
  );
}

InsightsLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

InsightsLayout.defaultProps = {
};

export default withStyles(styles)(InsightsLayout);
